import React, { useEffect } from "react";
import { useContext } from "react";
import { MemoryCountDownContext } from "../Context/MemoryCountDownContext";
import { MemoryTimerContext } from "../Context/MemoryTimerContext";
import { MemoryLevelContext } from "../Context/MemoryLevelContext";

const MemoryNextStageButton = ({nextStage}) => {

    const {levels, levelList, chooseStage, unsetLevels, handleShuffleCards, handleMemoryCompleted, getCards } = useContext(MemoryLevelContext);
    const {handleTimer, resetTime} = useContext(MemoryTimerContext);
    const {handleShowCounter, updateCountDown} = useContext(MemoryCountDownContext);

    const handleNextStageClick = (nextStageId, nextStageName, isSet) => {
        unsetLevels(false);
        setTimeout(() => {
            handleShowCounter(true); // show counter
            handleTimer(false); // reset time
            resetTime(); //reset time
            updateCountDown(false); //reset countdown
            handleMemoryCompleted(false); // reset memoryCompleted
            handleShuffleCards(); //shuffle cards
            chooseStage(nextStageId, nextStageName, isSet); //update stage
        }, 10);
    };

    return(
        <span className="button-container">
            <button className="button" onClick={() => handleNextStageClick(nextStage.stageId, nextStage.stage, true)}>
                <span className="label button--label">{nextStage.stage}</span>
                <span className="button--icon-container">
                    <i className="arrow arrow--right arrow--button" aria-hidden="true"></i>
                </span>
            </button>
        </span>
    );
};

export default MemoryNextStageButton;